export default {
    name: 'recommendationsservice',
    dependencies: ['xhrservice', 'sitesettings'],
    callable(xhrservice, siteSettings) {
        const RECOMMENDATIONS_API_URL = `${siteSettings.wwwSite}/match/ad/`;
        const DEFAULT_RECOMMENDER_ID = 'multi';

        function getRecommendations(vertical, adid, size) {
            const recommenderId = vertical || DEFAULT_RECOMMENDER_ID;
            const url = getApiUrl(recommenderId, adid, size);
            const reqOpts = {
                url,
                type: 'json',
                withCredentials: true,
            };
            return xhrservice.request(reqOpts);
        }

        function getApiUrl(recommenderId, adid, size) {
            const apiUrl = new URL(RECOMMENDATIONS_API_URL);
            if (adid === null) {
                apiUrl.pathname += `recommend/${recommenderId}`;
            } else {
                apiUrl.pathname += `mlt/${recommenderId}/${adid}`;
            }
            apiUrl.searchParams.set('rows', size || '4');
            return apiUrl.toString();
        }

        return {
            getRecommendations,
        };
    },
};



// WEBPACK FOOTER //
// ./services/recommendationsservice.js